export default "__VITE_ASSET__CQ$xhAgV__"